import Fingerprint2 from 'fingerprintjs2'
/* eslint-disabled */

export default {
  async print (token) {
    let em = this
    if (window.requestIdleCallback) {
      await requestIdleCallback(async function () {
        Fingerprint2.get(async function (components) {
          let murmur = Fingerprint2.x64hash128(components.map(function (pair) { return pair.value }).join(), 31)
          em.setData(components, murmur,token)
        })
      })

    } else {
      setTimeout(async function () {
        Fingerprint2.get(async function (components) {
          let murmur = Fingerprint2.x64hash128(components.map(function (pair) { return pair.value }).join(), 31)
          em.setData(components, murmur,token)
        })
      }, 500)
    }
  },
  async setData (components, murmur, token) {
    let agent = components.filter(f => { return f.key === 'userAgent' })[0].value
    let screen = components.filter(f => { return f.key === 'availableScreenResolution' })[0].value
    let timezone = new Date().getTimezoneOffset()
    //this.$store.commit('setAgent', this.agent[0].value)
    let b = {}
    var payload = {
      tk: token,
      lc: window.location.href,
      user: 'na',
      data: murmur,
      ua: agent,
      ss: screen,
      path: window.location.pathname,
      l: {
        0: b['has_lied_browser'],
        1: b['has_lied_languages'],
        2: b['has_lied_os'],
        3: b['has_lied_resolution']
      },
      tos: timezone,
      referr: document.referrer,
      ip: 0
    }
    window.localStorage.setItem('print',JSON.stringify(payload))
    console.log('Setting Data:', payload)
    this.sendData(payload)
    },
  sendData(payload){
    var opts = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }
    //this is the fingerprint api on aws api gaetway
    fetch('https://ktiei06800.execute-api.us-west-2.amazonaws.com/prod/prints', opts)
        .then((response) => response.json())
        .then((d)=>{})
  }
}